import { atom, useAtomValue, useSetAtom } from "jotai";
import { useCallback } from "react";

type DraftValues = Record<string, any>;

/** Never `atomWithStorage`: these are credentials, so a reload must lose them. */
const draftAtom = atom<{
  integrationId: string;
  slug: string | undefined;
  values: DraftValues;
  formId?: string;
} | null>(null);

export function useDataWarehouseConfigDraft(
  integrationId: string,
  workspaceSlug: string | undefined,
) {
  const draft = useAtomValue(draftAtom);
  const setDraft = useSetAtom(draftAtom);

  const saveDraft = useCallback(
    (values: DraftValues, formId?: string) => {
      setDraft({ integrationId, slug: workspaceSlug, values, formId });
    },
    [integrationId, workspaceSlug, setDraft],
  );

  const belongsHere =
    draft?.integrationId === integrationId && draft?.slug === workspaceSlug;

  return {
    draftValues: belongsHere ? draft.values : undefined,
    draftFormId: belongsHere ? draft.formId : undefined,
    saveDraft,
  };
}

export function useAssignDataWarehouseConfigDraft() {
  const setDraft = useSetAtom(draftAtom);
  return useCallback(
    (slug: string) => {
      setDraft((draft) => (draft ? { ...draft, slug } : draft));
    },
    [setDraft],
  );
}

export function useClearDataWarehouseConfigDraft() {
  const setDraft = useSetAtom(draftAtom);
  return useCallback(() => {
    setDraft(null);
  }, [setDraft]);
}
